<template>
  <v-list class="pa-0 mb-4" color="transparent">
    <!-- Title -->
    <div class="text-subtitle-1 font-weight-bold">
      {{ title }}
    </div>
    <p v-if="maxSelectableOptions > -1">
      {{ getMaxOptionsText() }}
    </p>
    <p :class="isSelectionInvalid() ? 'red--text' : ''">
      {{ getNrOfOptionsText() }}
    </p>

    <template v-for="(option, index) in options">
      <v-list-item :key="index" dense class="pa-0">
        <v-list-item-content class="pa-0">
          <v-row class="ma-0 pa-0" align="center">
            <div class="text-subtitle-1 font-weight-regular">
              {{ option.OptionName }}
            </div>

            <v-spacer />
            <div v-if="optionType === 'PictureResponse'">
              <ImageLoader
                :imageProps="imageProps"
                v-on:uploadImage="onImageChange(option, $event)"
                class="form-image-container pb-4"
              />
            </div>
            <div v-else-if="optionType === 'TextResponse'">
              <v-col class="d-inline-flex">
                <v-checkbox
                  v-model="option.Selected"
                  @change="toggleChange(option)"
                  class="ma-0"
                  hide-details="auto"
                >
                </v-checkbox>
                <v-text-field
                  counter
                  outlined
                  clearable
                  :hint="getTextResponseMaxLength(option)"
                  :maxLength="option.TextResponseMaxLength"
                  @input="updateInput(option)"
                  :label="$translate('ENTER_MESSAGE')"
                  v-model="option.TextResponse"
                ></v-text-field>
              </v-col>
            </div>
            <div v-else>
              <v-btn-toggle
                v-if="option.MaxQuantity > 1 || option.MaxQuantity == -1"
                rounded
                class="my-1"
              >
                <v-btn
                  small
                  :disabled="decreaseBtnDisabled(option)"
                  @click="decreaseQuantity(option)"
                >
                  <v-icon small>ti-minus</v-icon>
                </v-btn>
                <v-card
                  height="28"
                  min-width="60"
                  flat
                  outlined
                  tile
                  class="text-center px-3 text-subtitle-2 font-weight-medium d-flex"
                >
                  <div class="mx-auto">{{ option.Quantity }}</div>
                </v-card>
                <v-btn
                  small
                  :disabled="increaseBtnDisabled(option)"
                  @click="increaseQuantity(option)"
                >
                  <v-icon small>ti-plus</v-icon>
                </v-btn>
              </v-btn-toggle>
              <v-col v-else>
                <v-checkbox
                  v-model="option.Selected"
                  @change="toggleChange(option)"
                  class="ma-0"
                  hide-details="auto"
                >
                </v-checkbox>
              </v-col>
            </div>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import ImageLoader from '@/components/generalComponents/media/ImageLoader';
import utility from '@/shared/utility';
export default {
  name: '',
  props: {
    selectedProduct: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImageLoader,
  },
  watch: {
    selectedProduct() {
      this.init();
    },
  },
  data() {
    return {
      maxSelectableOptions: 0,
      minSelectableOptions: 0,
      options: {},
      numberOfSelectedOptions: 0,
      optionType: '',
      imageProps: {},
      title: this.$translate('PRODUCT_OPTIONS_TITLE'),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let firstOptionList;
      if (this.selectedProduct != null) firstOptionList = this.selectedProduct;
      if (firstOptionList == null) return;

      this.optionType = firstOptionList.Type;
      if (this.optionType === 'TextResponse')
        this.title = this.$translate('PRODUCT_OPTIONS_TEXT');
      else if (this.optionType === 'PictureResponse')
        this.title = this.$translate('PRODUCT_OPTIONS_PICTURE');
      else this.title = this.$translate('PRODUCT_OPTIONS_TITLE');

      this.maxSelectableOptions = firstOptionList.MaxSelectableOptions;
      this.minSelectableOptions = firstOptionList.MinSelectableOptions;

      let firstOptionGroup = this.getFirstOptionGroup(firstOptionList);
      if (
        firstOptionGroup == null ||
        firstOptionGroup.Options == null ||
        firstOptionGroup.Options.length == 0
      )
        return;

      this.options = firstOptionGroup.Options;

      for (const key in this.options) {
        let option = this.options[key];
        this.$set(option, 'Quantity', 0);
        this.$set(option, 'Selected', false);
        this.$set(option, 'TextResponse', '');
        this.$set(option, 'PictureResponse', '');
        option['Quantity'] = 0;
        option['Selected'] = false;
        option['TextResponse'] = '';
        option['PictureResponse'] = '';
      }

      this.imageProps = {
        id: 'imageLoader',
        src: '',
      };

      this.validateSelection();
    },
    getFirstOptionList() {
      if (
        this.selectedProduct != null &&
        this.selectedProduct.OptionLists != null &&
        this.selectedProduct.OptionLists.length > 0
      ) {
        return this.selectedProduct.OptionLists[0];
      }
      return {};
    },
    getFirstOptionGroup(optionList) {
      if (
        optionList == null ||
        optionList.OptionGroups == null ||
        optionList.OptionGroups.length == 0
      )
        return {};
      return optionList.OptionGroups[0];
    },
    increaseBtnDisabled(option) {
      if (
        option.Quantity < option.MaxQuantity ||
        this.maxSelectableOptions == -1 ||
        option.MaxQuantity == -1
      ) {
        return false;
      }
      return true;
    },
    decreaseBtnDisabled(option) {
      if (option.Quantity > 0) {
        return false;
      }
      return true;
    },
    increaseQuantity(option) {
      option.Quantity += 1;
      this.validateSelection();
    },
    decreaseQuantity(option) {
      option.Quantity -= 1;
      this.validateSelection();
    },
    toggleChange(option) {
      this.validateSelection();
    },
    updateInput(option) {
    if (option.TextResponse !== '') {
      option.Selected = true;
      option.Quantity = 1;
    } else {
      option.Selected = false;
      option.Quantity = 0;
    }
  },

    validateSelection() {
      this.numberOfSelectedOptions = 0;
      for (const key in this.options) {
        if (
          this.optionType === 'TextResponse' ||
          this.optionType === 'PictureResponse'
        ) {
          if (this.options[key].Selected) {
            this.numberOfSelectedOptions += 1;
          }
        } else {
          if (
            this.options[key].MaxQuantity > 1 ||
            this.options[key].MaxQuantity == -1
          ) {
            this.numberOfSelectedOptions += this.options[key].Quantity;
          } else if (this.options[key].Selected) {
            this.numberOfSelectedOptions += 1;
          }
        }
      }
      let invalidSelection = this.isSelectionInvalid();
      this.$emit('validateOptionSelection', invalidSelection);
    },
    isSelectionInvalid() {
      if (this.maxSelectableOptions == -1) {
        return this.numberOfSelectedOptions < this.minSelectableOptions;
      } else {
        return (
          this.numberOfSelectedOptions < this.minSelectableOptions ||
          this.numberOfSelectedOptions > this.maxSelectableOptions
        );
      }
      return false;
    },
    getMaxOptionsText() {
      if (this.minSelectableOptions != this.maxSelectableOptions) {
        let optionText =
          this.$translate('PRODUCT_OPTIONS_DESCR1') +
          `${this.minSelectableOptions}` +
          this.$translate('PRODUCT_OPTIONS_DESCR2') +
          `${this.maxSelectableOptions}`;
        return optionText;
      } else {
        let optionText =
          this.$translate('PRODUCT_OPTIONS_DESCR5') +
          `${this.minSelectableOptions}` +
          this.$translate('PRODUCT_OPTIONS_DESCR6');
        return optionText;
      }
    },
    getNrOfOptionsText() {
      if (this.isSelectionInvalid()) {
        if (this.numberOfSelectedOptions < this.minSelectableOptions) {
          // Construct the text that there are not enough options chosen.
          let optionShortage =
            this.minSelectableOptions - this.numberOfSelectedOptions;
          return (
            optionShortage.toString() +
            this.$translate('PRODUCT_OPTIONS_DESCR3')
          );
        } else if (
          this.maxSelectableOptions != -1 &&
          this.numberOfSelectedOptions > this.maxSelectableOptions
        ) {
          let optionSurplus =
            this.numberOfSelectedOptions - this.maxSelectableOptions;
          return (
            optionSurplus.toString() + this.$translate('PRODUCT_OPTIONS_DESCR4')
          );
        }
      }
      return '';
    },

    onImageChange(option, image) {
      option.Selected = true;
      option.Quantity = 1;
      option.PictureResponse = image;
      this.imageProps.src = image;
      this.validateSelection();
    },
    getTextResponseMaxLength(option) {
      let maxLength = option.TextResponseMaxLength;
      if (maxLength > 1) {
        const result = utility.sprintf(this.$translate('MAX_CHAR'), maxLength);
        return result;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-list-item--dense {
  min-height: 0px;
}
</style>
